import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, Radio } from 'react-mdl'
import { ChannelConfigStepper } from './ChannelConfigStepper';

import * as actions from '../actions/index'

/*global FB*/
/*global startFacebookSDK*/

export class FacebookStepper extends Component {

  static propTypes = {
    channel: PropTypes.object,
    channelType: PropTypes.string.isRequired,
    fetchChannelProviders: PropTypes.func.isRequired,
    channelAPI: PropTypes.func.isRequired,
    createChannel: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    addingChannel: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.state = {
      pages: [],
      providerId: null,
    }

    this.connect = this.connect.bind(this)
    this.getPages = this.getPages.bind(this);
    this.exchangeToken = this.exchangeToken.bind(this)
    this.pageSelected = this.pageSelected.bind(this);

    this.handleNextStep = this.handleNextStep.bind(this);
    this.renderStep = this.renderStep.bind(this);
  }

  componentWillMount() {
    if (this.props.addingChannel) {
      this.props.fetchChannelProviders((response, err) => {
        if (!err) {
          if ( response.length !== 0 ) {
            const providerId = response[0].id
            const fbAppId = response[0].params.app_id
            console.log('Got Facebook Provider', fbAppId);
            startFacebookSDK(fbAppId)
            this.setState({providerId, fbAppId})
          }
          else {
            this.props.dispatch(actions.setMessage('Provider Not Found'))
          }
        }
      })
    }
  }

  handleNextStep() {
    const { stepper } = this.channelConfigStepper
    const step = stepper.state.activeStep
    if (step === 1) {
      if (this.props.addingChannel) {
        //login -> get-non-expiring-access-token -> get pages
        this.connect()
      }
      else {
        this.nextStep()
      }
    }
    else if (step === 2) {
      if (this.props.addingChannel) {
        if (this.state.selectedPageId) {
          this.save()
        }
      }
      else {
        this.nextStep()
      }
    }
  }

  nextStep() {
    if (this.channelConfigStepper.isLastStep()) {
      this.props.goBack()
    }
    else {
      this.channelConfigStepper.stepper.nextStep()
    }
  }

  save() {
    const {pages, selectedPageId, providerId, fbAppId} = this.state
    const page = pages.filter(function(e) { return e.id === selectedPageId})[0]

    let newChannel = {enabled: true}
    newChannel.params = {
      "app_id": fbAppId,
      "page_id": page.id,
      "token": page.access_token
    }
    newChannel.title = page.name
    newChannel.provider = `${providerId}-${page.id}`

    this.props.createChannel(newChannel, (response, err) => {
      if (!err) {
        this.nextStep()
      }
    })
  }

  renderStep(stepJson, step) {
    if (step === 2) {
      if (this.props.addingChannel) {
        return <div>{this.renderPages()}</div>
      }
      else {
        return <div>Connected to page {this.props.channel ? this.props.channel.title : ""}</div>
      }
    }
  }

  render(){
    const { channel, channelType } = this.props
    return (
      <div>
        <ChannelConfigStepper ref={(s) => this.channelConfigStepper = s} channelType={channelType} channel={channel} onBeforeNextStep={this.handleNextStep} renderStep={this.renderStep}/>
      </div>
    )
  }

  // LOGIN

  connect() {
    // FB.getLoginStatus(function(response) {
      // if (response.status === 'connected') {
      //   // TODO: May need to check that we got all the permissions we need
      //   const shortLiveAccessToken = FB.getAuthResponse()['accessToken']
      //   this.exchangeToken(shortLiveAccessToken)
      //   this.setState({logged: true})
      // }
      // else {
        FB.login(function(response) {
          console.log('FB Response', response)
          if (response.status === 'connected') {
            const shortLiveAccessToken = FB.getAuthResponse()['accessToken']
            this.exchangeToken(shortLiveAccessToken)
            this.setState({logged: true})
          }
        }.bind(this), {scope: 'public_profile,email,manage_pages,pages_messaging'});
      // }
    // }.bind(this));
  }

  exchangeToken(shortLiveAccessToken) {
    const { providerId } = this.state
    if ( providerId !== undefined ) {
      this.props.channelAPI(providerId, 'exchange_token', {access_token: shortLiveAccessToken}, (response, err) => {
        if (!err) {
          this.getPages(response.access_token)
        }
      })
    }
    else {
      this.props.dispatch(actions.setMessage('Facebook App is not configured'))
    }
  }

  getPages(longLiveAccessToken) {
    FB.api('/me/accounts', {access_token: longLiveAccessToken}, function(response) {
      if (response.data.length > 0) {
        this.setState({pages: response.data, selectedPageId: response.data[0].id})
        this.nextStep()
      }
    }.bind(this));
  }

  //  SELECT PAGE

  pageSelected(event) {
    this.setState({selectedPageId: event.target.value});
  }

  renderPages() {
    const {pages, selectedPageId} = this.state

    if (pages.length === 0) {
      return <div></div>
    }

    return (
      <div>
        <RadioGroup name="page" container="ul" childContainer="li" value={selectedPageId} onChange={this.pageSelected}>
          {
            pages.map((page) => (
              <Radio key={page.id} value={page.id}>{page.name}</Radio>
            ))
          }
        </RadioGroup>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/FacebookStepper.js